import { createFailAction } from '../../redux-util/async-helpers';
import { createReducer } from '../../redux-util/general-helpers';
import {
  UPDATE_ADOPTION_ALL_USERS,
  UPDATE_ADOPTION_NAME,
  UPDATE_ADOPTION_USERS,
} from '../bridge-method-remap';
import { CREATE_ADOPTION, DELETE_ADOPTION } from '../bridge-methods';
import { getUid } from '../../../utils/uid';

const actions = [
  UPDATE_ADOPTION_NAME,
  UPDATE_ADOPTION_USERS,
  UPDATE_ADOPTION_ALL_USERS,
  DELETE_ADOPTION,
  CREATE_ADOPTION,
];

const handlers = {};
actions.forEach(a => {
  const key = createFailAction(a).type;
  handlers[key] = (state, action) => {
    return [
      ...state,
      {
        type: a,
        data: action.args[0],
        id: getUid(),
      },
    ];
  };
});

export default createReducer([], handlers);



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/errors/reducer.js